module.exports = __webpack_public_path__ + "img/red1.85c9d4e0.svg";